import React, {Component} from "react";
import { TableExhibit2 as DataTable } from "../table/table.component";
import { PaginationExhibit2 as Pagination } from "../table/pagination.component";
import { PaginationControl } from "../table/pagination-control";

export class TablePagination extends Component {
    constructor(props) {
        super(props);
        this.onColumnClickAction = this.onColumnClickAction.bind(this);
        this.state = {
            columns: {},
            pageList: []
        }
    }

    componentDidMount() {
        this.setState({
            columns: { ...this.props.columns },
            pageList: this.props.pageList
        });
    }

    componentWillUnmount(){
        this.setState({columns: {}, pageList: []})
    }

    componentDidUpdate(prevProps) {
        if (prevProps.columns !== this.props.columns || prevProps.pageList !== this.props.pageList) {
            this.setState({
                columns: { ...this.props.columns },
                pageList: this.props.pageList
            });
        }
    }

    onColumnClickAction = (columnClicked) => {
        if (this.props.onColumnClick) {
            const { columns, pageList } = this.state;
            const arrayColumns = [];
            let updatedColumns = {};
            Object.entries(columns).map(x => {
                arrayColumns.push(x);
            });

            let currColumn = arrayColumns.slice().filter(currCol => columnClicked === currCol[0])[0];
            Object.keys(columns).forEach(function (key) {
                if (key === currColumn[0]) {
                    updatedColumns[key] = { ...columns[key] };
                    updatedColumns[key].isSortedAsc = !currColumn[1].isSortedAsc;
                    updatedColumns[key].isSorted = true;
                } else {
                    updatedColumns[key] = { ...columns[key] };
                    updatedColumns[key].isSortedAsc = true;
                    updatedColumns[key].isSorted = false;
                }
            });

            this.props.onColumnClick(columnClicked, !currColumn[1].isSortedAsc);
            this.setState(prevState => ({
                columns: updatedColumns,
                //pageList: copyAndSort(prevState.pageList, currColumn[0], currColumn[1].isSortedAsc, currColumn[1].isDateTime)
            }));
        }
    };

    onColumnSearch = (value) => {
        this.props.onColumnSearch(value);
    };

    onColumnSearchChange = (event, value) => {
        this.props.onColumnSearchChange(event, value);
    };

    render() {
        const {
            isColSearchShow,
            pages,
            paginationAction,
            resizePage,
            rowClickAction,
            paginationHidden, 
            deleteAction,
            tableClassName,
            haveExternalDeleteBtn,
            showDetails,
            enableUpdate,
            classNameWrapper,
            modalPagination,
            hidePageSizeSelection,
            noDataAvailable,
            noAvailableData,
            hideStatusIcon,
            columnFormatRendering,
            warningIconConfig,
            uniqueKeyProp,
            isForApproval = false,
            notifCount
        } = this.props;

        const {
            columns,
            pageList
        } = this.state;

        return (
            <div>
                <div className="margin-bottom-16i">
                    <DataTable
                        tablePaginationKey={this.props.tablePaginationKey}
                        uniqueKeyProp={uniqueKeyProp}
                        isLoading={this.props.isLoading}
                        isNotSortable={this.props.isNotSortable}
                        onColumnClick={this.onColumnClickAction}
                        rowClickAction={rowClickAction}
                        columns={columns}
                        pageList={pageList.Items ?? pageList}
                        isColSearchShow={isColSearchShow}
                        onColumnSearch={this.onColumnSearch}
                        onColumnSearchChange={this.onColumnSearchChange}
                        haveLink={this.props.haveLink}
                        haveExternalDeleteBtn={haveExternalDeleteBtn}
                        deleteAction={deleteAction}
                        tableClassName={tableClassName}
                        showDetails={showDetails}
                        enableUpdate={enableUpdate}
                        classNameWrapper={classNameWrapper}
                        noDataAvailable={noDataAvailable}
                        noAvailableData={noAvailableData}
                        hideStatusIcon={hideStatusIcon}
                        columnFormatRendering={columnFormatRendering}
                        warningIconConfig={warningIconConfig}
                    />
                </div>
                {!paginationHidden && (pageList.Items
                    ? <PaginationControl
                        pageIndex={pageList.PageIndex}
                        total={pages.TotalEntries}
                        pageSize={pages.PerPage}
                        pageSizes={pages.PageSizes}
                        resizePage={resizePage}
                        changePage={paginationAction} 
                        hidePageSizeSelection={hidePageSizeSelection}
                        isForApproval={isForApproval}
                        pageDataCount={notifCount}
                    />
                    : <Pagination hidePageSizeSelection={hidePageSizeSelection} pages={pages} modalPagination={modalPagination} pageLength={this.props.totalPage} action={paginationAction} resizePage={resizePage}/>
                    )
                }
               
            </div>
        )
    }
}